import styled from 'styled-components';

const CollapseWrapper = styled.div`
    display: flex;
`;

export default CollapseWrapper;
